import * as Vue from "vue";
import * as mutations from "../../mutation-types"

export const processSubscriber = (store, item) => {
    store.commit(mutations.ADD_OR_UPDATE_SUBSCRIBER, item)
}

export const updateSubscribers = (store, {reference_type, reference_id, subscribers}) => {
    return axios.post(`/api/subscribers`, {
        reference_type,
        reference_id,
        subscribers
    }).then(res => {
        _.each(
            store.getters.subscribersByReference(reference_type, reference_id),
            item => store.commit(mutations.REMOVE_SUBSCRIBER, item)
        )

        _.each(res.data, item => processSubscriber(store, item))

        return res
    })
}
